import React, { useEffect, useState } from "react";
// constants
import { CARD_TYPE } from "../../../constants/CARD_DATA";
// apis
import { getConstantsCards, getConstantsCcds } from "../../../apis/code";
import { deleteFinancesAccounts, getFinancesAccounts, modifyFinancesScraping } from "../../../apis/finances/auth";
// components
import FinancialTable from "../../../components/Table/FinancialTable";
import Guide from "../../../components/Guide";
import Badge from "../../../components/Badge";
import personIcon from "../../../assets/images/icon/person-icon.svg"
import Icon from "../../../components/Icon";
// page
import CardAccount from "./Component/CardAccount";
import NickName from "./Component/NickNameModal";
// utils
import { flatten, forEach, get, isEmpty } from "lodash";
import { translation } from "../../../utils/translator";
import { isVerticalImg } from "../../../utils/image";
import { classnames } from "../../../utils/text";
import { viewLoading } from "../../../utils/loading";
import systemAlert from "../../../utils/systemAlert";
import { cardName } from "../../../utils/account-name";
// import { searchEmployee } from "../../../utils/employee";
// image
import defaultCardImage from "../../../assets/images/bank-card-images/default-card-img.png"
import CardEmployeeModal from "./Component/CardEmployeeModal";
import { FINANCE_SCRAPING_STATE } from "../../../constants/SCRAPING_DATA";

const CardAccountMapping = ({ permission }) => {
  const [fields] = useState([
    {
      key: "cardCompany",
      className: "finance-name",
      onValue: (value, field, data) => {
        const { cardImg, accountCompany, cardNo, accountType, nickName } = data
        return (
          <>
            <div style={ data.isUsing ? {} : {opacity: 0.5}}>
              <div
                className={classnames("card-img-wrap", {
                  vertical: isVerticalImg(cardImg),
                })}
              >
                <img src={cardImg || defaultCardImage} alt={accountCompany} onError={(e) => e.target.src = defaultCardImage} />
              </div>
              <Badge
                className={classnames("card-type-badge", {
                  vertical: isVerticalImg(cardImg),
                })}
                color={accountType === 'card' ? "secondary" : 'warning'}
                size="sm"
                label={translation(CARD_TYPE, accountType)}
              />
              <span
                className="card-name"
              >
                {cardName(accountCompany, cardNo, nickName)}
              </span>
            </div>
          </>
        );
      },
    },
    {
      key: "cardNm",
      className: "finance-description",
      onValue: (value, field, data) => {
        const target = FINANCE_SCRAPING_STATE.find(state => state.value === data.state) || {}
        return (
          <div className="nowrap" style={ data.isUsing ? {} : {opacity: 0.5}}>
            <span>{value}</span>
            {!isEmpty(target) && (
              <Badge
                className="margin-left-8"
                color={target.color}
                size="sm"
                label={target.label}
              />
            )}
          </div>
        )
      }
    },
  ]);
  const [status, setStatus] = useState({
    use: 0,
    normal: 0,
    error: 0,
  });
  const [list, setList] = useState([]);
  const [pcdList, setPcdList] = useState([]);
  const [ccdList, setCcdList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // 연동
  const [connectOpen, setConnectOpen] = useState(false);
  const [connectMode, setConnectMode] = useState('create')
  const [connectData, setConnectData] = useState({})
  const [originData, setOriginData] = useState([])
  // 직원 매핑
  const [employeeOpen, setEmployeeOpen] = useState(false)
  const [employeeList, setEmployeeList] = useState([])
  const [mappingCardData, setMappingCardData] = useState({})

  // nickname 모달
  const [detailOpen, setDetailOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formMode, setFormMode] = useState('create')

  useEffect(() => {
    submit();
  }, []);

  useEffect(() => {
    if (!isEmpty(list)) {
      let use = 0;
      let normal = 0;
      let error = 0;
      forEach(list, account => {
        if (account.isUsing === 1) use++
        // if (account.isValid === 1) normal++
        // if (account.isValid === 0) error++
        if (account.state === 1 || account.state === 9) normal++
        if (account.state === 2) error++
      })

      setStatus({
        use,
        normal,
        error
      })
    }
  }, [list])

  useEffect(() => {
    if (!employeeOpen) {
      setEmployeeList([])
      setMappingCardData({})
    }
  }, [employeeOpen])

  useEffect(() => {
    setList([...ccdList, ...pcdList]);
    if (!isEmpty(mappingCardData)) {
      // 직원 추가 모달에서 직원 추가시 직원 목록을 다시 세팅해줌
      const newCardData = [...ccdList, ...pcdList].find((card) => card.idx === mappingCardData.idx)
      setEmployeeList(newCardData.cardUseEmployees)
    }
  }, [pcdList, ccdList, mappingCardData]);

  const submit = () => {
    let count = 0;
    setIsLoading(true);
    // 개인 카드
    getConstantsCards().then((res) => {
      const pcdCodes = res.data.cards;
      getFinancesAccounts("card")
        .then((res) => {
          count++;
          const accountData = [...get(res, "data.accounts", [])];
          setOriginData(old => [...old, ...accountData])
          if (isEmpty(accountData)) return setPcdList([]);
          setPcdList(flatten(accountData.map(({ financeScrapings, ...account }) =>
            (financeScrapings || []).map((finance) => ({
              ...finance,
              accountCompany:
                translation(pcdCodes, account.cardCd, "code", "name"),
              accountType: 'card'
            }))))
          );
        })
        .finally(() => {
          if (count >= 2) {
            setIsLoading(false);
          }
        });
    });

    // 법인카드
    getConstantsCcds().then((res) => {
      const ccdCodes = res.data.ccds;
      getFinancesAccounts("ccd")
        .then((res) => {
          count++;
          const accountData = get(res, "data.accounts", []);
          setOriginData(old => [...old, ...accountData])

          if (isEmpty(accountData)) return setCcdList([]);
          setCcdList(
            flatten(accountData.map(({ financeScrapings, ...account }) =>
              (financeScrapings || []).map((finance) => ({
                ...finance,
                accountCompany:
                  translation(ccdCodes, account.cardCd, "code", "name"),
                accountType: 'ccd'
              }))))
          );
        })
        .finally(() => {
          if (count >= 2) {
            setIsLoading(false);
          }
        });
    });
  };

  const setUsingAction = (checked, idx) => {
    const formData = {
      isUsing: checked ? 1 : 0,
      isScrap: checked ? 1 : 0,
    }
    viewLoading(true)
    modifyFinancesScraping(idx, formData).then((res) => {
      submit();
    }).catch(() => { }).finally(() => {
      viewLoading(false)
    })
  }

  const setScrapAction = (checked, idx) => {
    const formData = {
      isScrap: checked ? 1 : 0
    }
    viewLoading(true)
    modifyFinancesScraping(idx, formData).then((res) => {
      submit();
    }).catch(() => { }).finally(() => {
      viewLoading(false)
    })
  }

  const headerbutton = [
    {
      label: "새 신용카드 연동",
      color: "line",
      size: "sm",
      action: () => {
        setConnectOpen(true);
        setConnectMode('create');
      },
      className: "float-right",
    },
  ];

  const controller = {
    rowButtons: [
      {
        isHide: !(permission.level > 1),
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (data) => {
          systemAlert(
            <div>
              <Guide
                color='red'
                children={<>해당 인증정보의 모든 카드정보가 삭제됩니다.</>} />
              <p className="margin-top-10">인증정보를 삭제하시겠습니까?</p>
            </div>, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  viewLoading(true)
                  deleteFinancesAccounts(data.financeAccountIdx).then(() => { submit() }).catch(() => { }).finally(() => viewLoading(false))
                }
              }
            ]
          })
        },
      },
      {
        isHide: !(permission.level > 1),
        label: "수정",
        type: "edit",
        action: (data) => {
          const financeData = originData.find((origin) => origin.idx === data.financeAccountIdx)
          setConnectOpen(true);
          setConnectData(financeData)
          setConnectMode('modify');
        },
      },
      {
        isHide: !(permission.level > 1),
        label: "별칭",
        type: "nickname",
        action: (data) => {
          setFormData({...data});
          setDetailOpen(true);
          setFormMode('modify')
        },
      },
    ],
    setUsingAction,
    setScrapAction,
    switchDisabled: !(permission.level > 1),
    controlButton: {
      label: (data) => {
        return (
          isEmpty(data.cardUseEmployees) ? (<div style={ data.isUsing ? {} : {opacity: 0.5}}><span className="empty-employees"><Icon src={personIcon} /> 사람선택</span></div>) : (<div style={ data.isUsing ? {} : {opacity: 0.5}}><span className="employees"><Icon src={personIcon} />사람 <span className="employee-count">{data.cardUseEmployeeCount}</span>명</span></div>)
        )
      },
      action: (data) => {
        setEmployeeList(data.cardUseEmployees)
        setMappingCardData(data)
        setEmployeeOpen(true)
      }
    }
  }

  useEffect(() => {
    if (!connectOpen) {
      setConnectMode('create')
    }
  }, [connectOpen])

  return (
    <>
      <FinancialTable
        title="신용카드 매입"
        fields={fields}
        list={list}
        status={status}
        isLoading={isLoading}
        buttons={permission.level > 1 ? headerbutton : []}
        controller={controller}
      />
      <CardAccount
        open={connectOpen}
        setOpen={setConnectOpen}
        mode={connectMode}
        setMode={setConnectMode}
        financeData={connectData}
        setFinanceData={setConnectData}
        submit={submit}
      />
      <CardEmployeeModal
        permission={permission}
        open={employeeOpen}
        setOpen={setEmployeeOpen}
        employeeList={employeeList}
        submit={submit}
        cardData={mappingCardData}
      />
      <NickName
        mode={formMode}
        selectedData={formData}
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={submit}
      />
    </>
  );
};

export default CardAccountMapping;
